import { type RenderCanvas, renderCanvas } from "./canvas-surface";
import { applyHueSaturationPixelFallback } from "./native-pixel-effects.js";
let reliable: boolean | undefined;
/** Same feature check and filter order as the original createWarpSourceCanvas. */
function supported() {
  if (reliable !== undefined) return reliable;
  try {
    const source = renderCanvas(),
      output = renderCanvas();
    source.width = source.height = output.width = output.height = 1;
    const s = source.getContext("2d")!,
      c = output.getContext("2d")!;
    s.fillStyle = "#ff0000";
    s.fillRect(0, 0, 1, 1);
    c.filter = "hue-rotate(180deg) saturate(200%)";
    c.drawImage(source, 0, 0);
    const p = c.getImageData(0, 0, 1, 1).data;
    reliable = p[1]! > 40 || p[2]! > 40;
  } catch {
    reliable = false;
  }
  return reliable;
}
export function applyImageColorCorrection(
  source: RenderCanvas,
  hue: number,
  saturation: number,
) {
  if (!hue && !saturation) return;
  const ctx = source.getContext("2d")!;
  if (!supported()) {
    applyHueSaturationPixelFallback(
      ctx,
      source.width,
      source.height,
      hue,
      saturation,
    );
    return;
  }
  const output = renderCanvas();
  output.width = source.width;
  output.height = source.height;
  const c = output.getContext("2d")!;
  c.filter = `hue-rotate(${hue}deg) saturate(${Math.max(0, 100 + saturation)}%)`;
  c.drawImage(source, 0, 0);
  ctx.save();
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.clearRect(0, 0, source.width, source.height);
  ctx.drawImage(output, 0, 0);
  ctx.restore();
}
